import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { getSite } from '../../infrastructure/site/SiteProvider';
import { Image } from '../../uiComponents/layout/Image';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import {
  Row,
  Col,
  Panel,
} from '../../uiComponents/bootstrap-components/BootstrapComponents';
import Auth from '../auth';
import { Spinner } from '../../uiComponents/Spinner';
import { Route } from 'react-router-dom';

export interface LoginProps extends RouteComponentProps<any> {
  redirectTo?: string;
  fromTilmeldingFlow?: boolean;
}

export interface LoginState {
  uniLoginUrl?: string;
  isUdvikling: boolean;
}

class Login extends React.Component<LoginProps, any> {
  constructor(props: LoginProps) {
    super(props);

    this.state = { uniLoginUrl: undefined, isUdvikling: false };
  }

  componentDidMount() {
    var self = this;
    const callbackUrl = window.location.origin + '/auth';
    createApiCaller()
      .getUniLoginUrl(callbackUrl)
      .then((response) => {
        self.setState({
          uniLoginUrl: response.url,
          isUdvikling: response.udvikling,
        });
      });
  }

  onTilmeldClicked() {
    localStorage.setItem('tilmeld', 'true');
  }

  render() {
    // if (isDriftSite() && this.props.redirectTo === undefined && getSite().redirectTilNvHus) {
    //    window.location.href = 'http://www.nvhus.dk/naturfagsmaraton/';

    //    return <div />;
    // }

    const velkommenTekst = (
      <div>
        <p>For at bruge {getSite().navn} skal du logge ind.</p>
        <p>
          Når du trykker på "Login" - knappen nedenfor, vil du blive omdirigeret
          til Uni-Logins side. Her skal du indtaste brugernavn og password. Du
          vil derefter blive stillet tilbage til {getSite().navn}.
        </p>
      </div>
    );

    if (this.state.uniLoginUrl === undefined) {
      return <Spinner />;
    } else {
      if (this.state.isUdvikling) {
        var authComponent = () => <Auth isUdvikling={true} {...this.props} />;
        return <Route path="/" component={authComponent} />;
      } else {
        if (
          this.props.fromTilmeldingFlow !== undefined &&
          this.props.fromTilmeldingFlow
        ) {
          return (
            <div className="tilmelding-login">
              <Panel>
                <Row>
                  <Col md={6}>
                    <div id="tilmelding-login-image" />
                  </Col>
                  <Col md={6}>
                    <h1>Tilmelding til {getSite().navn}</h1>
                    {velkommenTekst}
                    <a
                      className="btn btn-primary"
                      href={this.state.uniLoginUrl}
                    >
                      Login
                    </a>
                  </Col>
                </Row>
              </Panel>
            </div>
          );
        } else {
          return (
            <PageWrapper>
              <ContentWrapper>
                <SectionGroup>
                  <Section>
                    <div id="login-page">
                      <Row>
                        <Col md={6}>
                          <h1>Velkommen til {getSite().navn}</h1>
                          <p>
                            Hvis du er tilmeldt {getSite().navn}, kan du finde
                            opgaverne ved at logge ind. Hvis du ikke er tilmeldt
                            endnu, skal du klikke på Tilmeld i stedet.
                          </p>
                        </Col>
                        <Col md={6}>
                          <Row>
                            <Col md={12} className={'login-knapper'}>
                              <a
                                className="btn btn-primary"
                                href={this.state.uniLoginUrl}
                              >
                                Login som elev
                              </a>
                              <a
                                className="btn btn-primary"
                                href={this.state.uniLoginUrl}
                              >
                                Login som lærer
                              </a>
                              <a
                                className="btn btn-primary"
                                onClick={() => this.onTilmeldClicked()}
                                href={this.state.uniLoginUrl}
                              >
                                Tilmeld
                              </a>
                              <a className="email-login-btn" href="/emaillogin">
                                Login som ekstern &#187;
                              </a>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </Section>
                </SectionGroup>
                <SectionGroup>
                  <Section>
                    <Row>
                      <Col md={6}>
                        <h2 className="forside-overskrift">
                          Om Natursfagsmaraton
                        </h2>
                        <p>
                          Naturfagsmaraton er et undervisningsforløb til 5. og
                          6. klasser i hele landet. Eleverne skal arbejde med
                          opgaver hjemme på skolen i 12-20 lektioner.
                        </p>
                        <br />
                        <p>
                          Opgaverne er forberedelse til en konkurrencedag i
                          foråret, hvor op til 24 lokale klasser dyster mod
                          hinanden om de bedste løsningsforslag.
                        </p>
                        <br />
                        <a
                          href={
                            'https://www.nvhus.dk/undervisning/naturfagsmaraton/om-naturfagsmaraton/'
                          }
                          className="btn btn-primary"
                          target="_blank"
                        >
                          Læs mere om {getSite().navn}
                        </a>
                      </Col>
                      <Col md={6}>
                        <Image
                          source="forside/forside_right_1.jpg"
                          className="forside-img"
                        />
                      </Col>
                    </Row>
                  </Section>
                </SectionGroup>
                <SectionGroup>
                  <Section>
                    <Row>
                      <Col md={6}>
                        <h2 className="forside-overskrift">
                          Flere tilbud fra Naturvidenskabernes Hus
                        </h2>
                        <p>
                          Er du interesseret i undervisning, der giver dig og
                          dine elever et åbent skole-forløb, der giver
                          engagement og læring i din klasse? Vil du introducere
                          dine elever til interessante, faglige rollemodeller,
                          der kan give et helt nyt perspektiv på uddannelse og
                          job? Naturvidenskabernes Hus tilbyder gratis
                          undervisningsforløb med virksomhedsbesøg i hele landet
                          målrettet udskolingen.
                        </p>
                        <br />
                        <a
                          href={'https://www.nvhus.dk/undervisning/'}
                          className="btn btn-primary"
                          target="_blank"
                        >
                          Læs mere her
                        </a>
                      </Col>
                      <Col md={6}>
                        <Image
                          source="forside/forside_right_2.jpg"
                          className="forside-img"
                        />
                      </Col>
                    </Row>
                  </Section>
                </SectionGroup>
              </ContentWrapper>
            </PageWrapper>
          );
        }
      }
    }
  }
}

export default Login;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/login/Login.tsx